import BasePage from '../../components/base-page/base-page';
import Carousel from '../../components/carousel/carousel';
import VideoModal from '../../components/video-modal/video-modal';
import ValueSlider from '../../components/value-slider/value-slider';
import PromoApps from '../../components/promo-apps/promo-apps';
import ContextApps from '../../components/context-apps/context-apps';

import breakpoints from '../../config/breakpoints';

import './affiliates-landing.scss';

class AffiliatesLanding extends BasePage {
  ui = {
    testimonialsCarousel: '.js-testimonials-carousel',
    shortcutsCarousel: '.js-shortcuts-carousel',
    contextApps: '.js-context-apps',
    valueSlider: '.js-value-slider',
    videoTestimonialsCarousel: '.js-video-testimonials-carousel',
  };

  onInit() {
    super.onInit();

    this.valueSlider = new ValueSlider({ rootElement: this.ui.valueSlider });
    this.valueSlider.init();

    this.testimonialsCarousel = new Carousel({
      rootElement: this.ui.testimonialsCarousel,
      slidesPerPage: {
        [breakpoints.sm]: 2,
        [breakpoints.lg]: 3,
      },
    });
    this.testimonialsCarousel.init();

    this.shortcutsCarousel = new Carousel({
      rootElement: this.ui.shortcutsCarousel,
      slidesPerPage: {
        [breakpoints.sm]: 2,
        [breakpoints.lg]: 3,
      },
    });
    this.shortcutsCarousel.init();

    new ContextApps().init();

    new VideoModal().init();

    this.videoTestimonialsCarousel = new Carousel({
      rootElement: this.ui.videoTestimonialsCarousel,
    });
    this.videoTestimonialsCarousel.init();

    new PromoApps().init();
  }
}

export default AffiliatesLanding;

AffiliatesLanding.initOnDomLoaded();
